import React from 'react'
import PropTypes from 'prop-types'
import HHNumberField from './HHNumberField'

const HHPriceField = ({
  sx = undefined,
  name,
  disabled = false,
  label = undefined,
  placeholder = '0.00',
  size = 'medium',
  autocomplete = 'off',
  dollarPrefix = true,
  thousandSeparator = true,
  decimalSeparator = '.',
  decimalScale = 2,
  variant = 'outlined',
  allowNegative = true,
  rules = undefined,
  required = false,
  fullWidth = false,
  valueIsNumericString = false,
  endLabelIcon = undefined,
  InputProps,
  error = '',
  showErrorMessage = false,
  ...rest
}) => {
  return (
    <HHNumberField
      showErrorMessage={showErrorMessage}
      sx={sx}
      name={name}
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      size={size}
      autocomplete={autocomplete}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      variant={variant}
      allowNegative={allowNegative}
      rules={rules}
      required={required}
      fullWidth={fullWidth}
      valueIsNumericString={valueIsNumericString}
      dollarPrefix={dollarPrefix}
      InputProps={{ ...InputProps }}
      endLabelIcon={endLabelIcon}
      error={error}
      {...rest}
    />
  )
}

HHPriceField.propTypes = {
  sx: PropTypes.object,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  autocomplete: PropTypes.string,
  dollarPrefix: PropTypes.bool,
  thousandSeparator: PropTypes.bool,
  decimalScale: PropTypes.number,
  decimalSeparator: PropTypes.oneOf(['.', ',', false, true]),
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  allowNegative: PropTypes.bool,
  rules: PropTypes.object,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  valueIsNumericString: PropTypes.bool,
  endLabelIcon: PropTypes.node,
  InputProps: PropTypes.object,
  error: PropTypes.string,
  showErrorMessage: PropTypes.bool,
}

export default HHPriceField
